import { RestManager } from '@/newApi/services/rest/RestManager';
import { getApiHost } from '@/appSettings';
import type { UnionSalaryReviewResponse, UnionSalaryReviewEmploymentResponse, SalaryReviewItem } from '@sysarb/sysarb-types/services/v1/pay-management';
import { useLoginStore } from '@/login/stores/useLoginStore';

const payManagementService = new RestManager(`https://${getApiHost()}/pay-management-service`);

export function abort(): void {
    payManagementService.abort();
}

/**
 * Get a salary review menu list
 */
export async function getSalaryReviewMenuList(): Promise<SalaryReviewItem[]> {
    const { instance } = useLoginStore();
    return payManagementService.get<SalaryReviewItem[]>(`v1/${instance}/pay-management/union-review-menu-list`);
}

/**
 * Get the selected SalaryReview
 * @param salaryReviewId The id of the salary review to fetch
 */
export async function getSalaryReview(salaryReviewId: string): Promise<UnionSalaryReviewResponse> {
    const { instance } = useLoginStore();
    return payManagementService.get<UnionSalaryReviewResponse>(`v1/${instance}/pay-management/union-review/${salaryReviewId}`);
}

/**
 * Get list of SalaryReviewEmployments the current user has access to
 * @param salaryReviewId The id of the salary review
 */
export async function getUnionSalaryReviewEmployments(salaryReviewId: string): Promise<UnionSalaryReviewEmploymentResponse[]> {
    const { instance } = useLoginStore();
    return payManagementService.get<UnionSalaryReviewEmploymentResponse[]>(`v1/${instance}/pay-management/union-employments/${salaryReviewId}/employments`);
}
